import scrollTo from 'vue-scrollto/src/scrollTo';
import { helpers } from 'vuelidate/lib/validators';

export function url(value) {
  const urlRegex = /^(?:(?:(?:https?|ftp):\/\/)|(?:))(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;
  return helpers.regex('url', urlRegex)(value);
}

export default {
  required(field) {
    return () => field.required || 'Field is required';
  },
  url(field) {
    return () => field.url || 'Field must be a valid url';
  },
  email(field) {
    return () => field.email || 'Field must be a valid email';
  },
  decimal(field) {
    return () => field.decimal || 'Field must be a decimal number';
  },
  numeric(field) {
    return () => field.numeric || 'Field must be a number';
  },
  minLength(field) {
    if (!field.$dirty) {
      return true;
    }
    return () => field.minLength || `The field must contain at least ${field.$params.minLength.min} characters`;
  },
  maxLength(field) {
    return () => field.maxLength || `The field must contain no more than ${field.$params.maxLength.max} characters`;
  },
  length(field) {
    if (!field.$dirty) {
      return true;
    }
    return () => (field.minLength && field.maxLength) || `The field must contain ${field.$params.minLength.min} characters`;
  },
};

/**
 * Scroll to first error
 * Returns true if an error input was found
 *
 * @param {object} form
 * @param {object} refs
 *
 * @return {boolean}
 */
export function scrollToError(form, refs) {
  const ref = Object.keys(refs).find(key => {
    return form[key] && form[key].$error && refs[key];
  });
  if (ref) {
    scrollTo(refs[ref].$el, 1000, { offset: -70, onDone: () => refs[ref].focus() });
    return true;
  }
  return false;
}
